module.exports = __webpack_public_path__ + "26045c1f147d687721a1c11620786851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/admin-black.png
// module id = 205
// module chunks = 0